export const COUNTRY_OPTIONS = [
  { code: 'FR', label: 'France' },
  { code: 'BE', label: 'Belgique' },
  { code: 'CH', label: 'Suisse' },
  { code: 'CA', label: 'Canada' },
  { code: 'US', label: 'Etats-Unis' },
  { code: 'GB', label: 'Royaume-Uni' },
  { code: 'DE', label: 'Allemagne' },
  { code: 'ES', label: 'Espagne' },
  { code: 'IT', label: 'Italie' },
  { code: 'PT', label: 'Portugal' },
  { code: 'NL', label: 'Pays-Bas' },
  { code: 'LU', label: 'Luxembourg' },
  { code: 'SE', label: 'Suede' },
  { code: 'NO', label: 'Norvege' },
  { code: 'DK', label: 'Danemark' },
  { code: 'FI', label: 'Finlande' },
  { code: 'IE', label: 'Irlande' },
  { code: 'AU', label: 'Australie' },
  { code: 'NZ', label: 'Nouvelle-Zelande' },
  { code: 'OTHER', label: 'Autre / Non liste' },
];

export const LANGUAGE_OPTIONS = [
  { code: 'fr', label: 'Français', native: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English', native: 'English', flag: '🇬🇧' },
];

export const CUSTOMER_TYPES = [
  { value: 'individual', label: 'Particulier' },
  { value: 'business', label: 'Entreprise' },
];
